import React from "react";
import BeforeAfterSlider from "../../../components/BeforeAfterSlider"; // Import Before & After slider component

const galleryImages = [
  {
    before: "/assets/images/Gallery-before-1.jpg",
    after: "/assets/images/Gallery-after-1.jpg",
  },
  {
    before: "/assets/images/Gallery-before-2.jpg",
    after: "/assets/images/Gallery-after-2.jpg",
  },
  {
    before: "/assets/images/Gallery-before-3.jpg",
    after: "/assets/images/Gallery-after-3.jpg",
  },
  {
    before: "/assets/images/Gallery-before-4.jpg",
    after: "/assets/images/Gallery-after-4.jpg",
  },
  {
    before: "/assets/images/Gallery-before-5.jpg",
    after: "/assets/images/Gallery-after-5.jpg",
  },
];

const GallerySection = () => {
  return (
    <section id="gallery" className="bg-gray-900 py-20">
      <div className="container mx-auto px-6">
        {/* Decorative Divider */}
        <div className="w-24 h-1 bg-gradient-to-r from-[#0D47A1] to-[#1C9BF8] mx-auto mb-6"></div>
        {/* Section Title */}
        <h2 className="text-5xl font-bold text-white uppercase tracking-wide mb-12 text-center">
          Gallery
        </h2>

        {/* Grid Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {galleryImages.map((image, index) => (
            <div key={index} className="rounded-lg overflow-hidden shadow-lg">
              <BeforeAfterSlider before={image.before} after={image.after} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
